import { Box, Image, Text } from "@chakra-ui/react";
import { Player } from "@lottiefiles/react-lottie-player";
import React from "react";
import { SecondaryButton } from "../atoms/HJSButton";

const MessageScreen = ({
  message,
  src,
  alt,
  showBtn = false,
}: {
  message: string | JSX.Element;
  src: string;
  alt: string;
  showBtn?: boolean;
}): JSX.Element => {
  return (
    <>
      <Box px={6} mb={2}>
        {/* <Image src={src} alt={alt} boxSize={96} mx="auto" /> */}
        <Player
          autoplay={true}
          loop={true}
          // style={{ height: "500px" }}
          src={src}
          className="md:h-[500px]"
        />
        <Box
          textAlign="center"
          fontSize={[14, 14, 15, 20]}
          fontWeight={700}
          mt={2}
          mx="auto"
          maxWidth={700}
          width="fit-content"
        >
          {message}
        </Box>
        {showBtn && <SecondaryButton> Apply for Jobs </SecondaryButton>}
      </Box>
    </>
  );
};

export default MessageScreen;
